import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";
import appendToFormData from "Utilities/appendToFormData";

import appendAddressToFormData from "../appendAddressToFormData";

/**
 * POST an IIG single-field Address response, including the optional
 * cross-network sync. Mirrors the wire contract of legacy
 * `updateSingleField.js#saveExtendedField`.
 *
 * @param {object} params
 * @param {number} params.userID
 * @param {object} params.address           hook value shape (addr1/city/state/zip/country/...)
 * @param {number} params.networkFieldID
 * @param {number} params.fieldTypeInstanceID
 * @param {number|null} params.iigRequestID
 * @param {boolean} params.shareWithOtherNetworks
 * @param {Array<object>} [params.selectedNetworks]  the chosen otherNetworks objects
 */
export default function saveIIGAddress({
  userID,
  address,
  networkFieldID,
  fieldTypeInstanceID,
  iigRequestID,
  shareWithOtherNetworks,
  selectedNetworks,
}) {
  const endpoint = `/user/${userID}/saveExtendedFieldResponseIncludingOtherNetworks`;
  const formData = new FormData();

  appendAddressToFormData(formData, address);

  formData.append("networkFieldID", networkFieldID);
  formData.append("fieldTypeInstanceID", fieldTypeInstanceID);
  if (iigRequestID != null) formData.append("iigRequestID", iigRequestID);

  formData.append("shareWithOtherNetworks", shareWithOtherNetworks ? "1" : "0");
  if (shareWithOtherNetworks && selectedNetworks?.length) {
    appendToFormData(formData, { selectedNetworks });
  }

  return new FnrFetch3(endpoint, formData).post();
}
